"use client";

import { useId } from "react";
import { MemoizedMarkdown } from "@/components/ui/MemoizedMarkdown";
import { looksLikeMarkdown, LLM_NODE_TYPE_RE } from "../detect";
import { PRIORITY, type ValueRenderer } from "../types";

const CONTENT_KEYS = new Set(["output", "text", "message", "body", "content", "summary", "result"]);

export const MarkdownRenderer: ValueRenderer = {
  id: "markdown",
  match: (value, ctx) => {
    if (typeof value !== "string" || value.length < 1) return null;
    const keyHint = ctx.key != null && CONTENT_KEYS.has(ctx.key);
    const nodeHint = ctx.nodeType != null && LLM_NODE_TYPE_RE.test(ctx.nodeType);
    if (keyHint || nodeHint) return { priority: PRIORITY.CONTEXT_HINTED, confidence: "high" };
    if (looksLikeMarkdown(value)) return { priority: PRIORITY.CONTENT_SNIFFED, confidence: "low" };
    return null;
  },
  Component: ({ value }) => {
    const id = useId();
    return (
      <div className="text-sm">
        <MemoizedMarkdown content={value as string} id={id} />
      </div>
    );
  },
};
